import styled from 'styled-components';

export const PasswordPassedLine = styled.span`
  border-radius: 2px;
  background: #0573E4;
  width: 55px;
  height: 4px;
  margin-right: 8px;
`

export const PasswordLine = styled.span`
  border-radius: 2px;
  background: #DAE6F2;
  width: 55px;
  height: 4px;
  margin-right: 8px;
`
export const Val = styled.div`
  display: flex;
  width: 100%;
  margin-top: 16px;
  font-size: 14px;
  align-items: center;
`
export const Divider = styled.div`
  content: '';
  border-top: 1px solid rgba(1, 18, 36, 0.12);
  margin: 32px 0;
  width: 100%;
`